const stylesConfig = {
    desktop_max_width: 1200,
    mobile_max_width: 900
};

export default stylesConfig;
